var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ColumnBaseComponent } from '../base/columnbase.component';
import { ColumnService } from '../column/column.service';
import { ColumnBaseService } from '../base/columnbase.service';
var EmailComponent = /** @class */ (function (_super) {
    __extends(EmailComponent, _super);
    function EmailComponent(service, baseService) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        return _this;
    }
    EmailComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    EmailComponent.decorators = [
        { type: Component, args: [{
                    selector: 'column-email',
                    template: '<input type="email" name="{{ colKey }}" attr.name="{{ colKey }}" [placeholder]="col" [(ngModel)]="val" (change)="onChange(val)" [key]="key" [col]="col" columnDir>',
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    EmailComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService }
    ]; };
    return EmailComponent;
}(ColumnBaseComponent));
export { EmailComponent };
//# sourceMappingURL=email.component.js.map